import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { commodityOptions } from 'data';
import NumberUtils from 'helpers/numberUtils';

const numberUtils = new NumberUtils();
const formatCurrencyOrBlank = (value) =>
  value === null || value === undefined || value === ''
    ? ''
    : numberUtils.formatToCurrency(Number(value));

// Create styles
const styles = StyleSheet.create({
  title: {
    fontSize: 20,
    textAlign: 'center',
    color: 'red',
    marginTop: 30,
    marginBottom: 15,
  },
  table: {
    width: '100%',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#808080',
    padding: 5,
  },
  tableHeaderCell: {
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    padding: 5,
    backgroundColor: 'white',
  },
  tableRowAlt: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    padding: 5,
    backgroundColor: '#f9f9f9',
  },
  commodityColumn: {
    flex: 4,
    fontSize: 10,
  },
  percentageColumn: {
    flex: 1,
    fontSize: 10,
    textAlign: 'center',
  },
  deductibleColumn: {
    flex: 1,
    fontSize: 10,
    textAlign: 'right',
  },
});

const Commodities = ({ commoditiesList }) => (
  <>
    <Text style={styles.title}>Commodities Hauled</Text>

    <View style={styles.table}>
      <View style={styles.tableHeader}>
        <Text
          style={[styles.tableHeaderCell, styles.commodityColumn]}
        >
          Commodity Type
        </Text>
        <Text
          style={[styles.tableHeaderCell, styles.percentageColumn]}
        >
          % of Hauls
        </Text>
        <Text
          style={[styles.tableHeaderCell, styles.deductibleColumn]}
        >
          Deductible
        </Text>
      </View>

      {commoditiesList.map((commodity, index) => (
        <View
          key={commodity.type}
          style={
            index % 2 === 0 ? styles.tableRow : styles.tableRowAlt
          }
        >
          <Text style={styles.commodityColumn}>
            {
              commodityOptions?.find(
                (cmodt) => cmodt.value === commodity.commodityKey
              )?.label
            }
          </Text>
          <Text style={styles.percentageColumn}>
            {commodity.commodityPercentage} %
          </Text>
          <Text style={styles.deductibleColumn}>
            {formatCurrencyOrBlank(commodity.deductible)}
          </Text>
        </View>
      ))}
    </View>
  </>
);

export default Commodities;
